export default {
  isLoading: false,
  isSuccess: false,
  isError: false,
  description: '',
  viewDocumentos: false,
  listDocuments: [],
  infoDocuments: {},

};

